import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { TranslateText } from "../schemas/schemas_0";
export { $Command };
export class TranslateTextCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("AWSShineFrontendService_20170701", "TranslateText", {})
    .n("TranslateClient", "TranslateTextCommand")
    .sc(TranslateText)
    .build() {
}
